import fetcher from '../utils/api';

const authService = {
  emailPassword: async (email, password) =>
    fetcher('tokens/obtain/', 'POST', false, {
      email,
      password
    }),
  emailOtp: async (email, otp) =>
    fetcher('tokens/obtain/', 'POST', false, {
      email,
      otp
    }),
  google: async (authCode, redirectURL) =>
    fetcher('weblogin/social/jwt-pair/', 'POST', false, {
      provider: 'google-oauth2',
      redirect_uri: redirectURL,
      code: authCode
    }),
  googleOneTap: async (credential) =>
    fetcher('weblogin/social/jwt-pair/', 'POST', false, {
      credential,
      is_one_tap: true
    }),
  googlePopup: async (credential) =>
    fetcher('weblogin/social/jwt-pair/', 'POST', false, {
      credential,
      is_popup: true
    }),
  signUp: async (
    email,
    firstName,
    lastName,
    password,
    confirmPassword,
    inviteUrl = '',
    save = '',
    signupSource = '',
    verifyEmail = false,
    cloudflareToken = '',
    fsUUID = '',
    inviteCode = ''
  ) =>
    fetcher('users/', 'POST', false, {
      email,
      first_name: firstName,
      last_name: lastName,
      password,
      confirm_password: confirmPassword,
      invite_url: inviteUrl,
      save_scribe_id: save,
      signup_source: signupSource,
      cloudflare_token: cloudflareToken,
      fs_uuid: fsUUID,
      invite_code: inviteCode
    }),
  isDomainSSOEnabled: async ({ domain, email }) =>
    fetcher('domain/domain/', 'POST', false, {
      domain,
      email
    }),
  refreshToken: async (refresh) =>
    fetcher('tokens/refresh/', 'POST', false, {
      refresh
    }),
  signOutFromServer: async (allDevices) => {
    return fetcher(`logout/?all_devices=${allDevices ? 'true' : 'false'}`, 'DELETE', true);
  }
};

export default authService;
